import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 50px 30px;
  gap: 20px;
  box-sizing: border-box;
  position: relative;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`
export const DatePickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  [data-slot='label']{
    display: none;
  }
  [data-slot='input-wrapper']{
    border-radius: 4px;
    height: 40px;
    border:${({theme}) => `1px solid ${theme.grey[350]}`};
    &:focus{
      border: ${({theme}) => theme.isDark ? `1px solid #4671F6` : `1px solid ${theme.primary[300]}`};
      box-shadow: ${({theme}) => theme.isDark ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)' : `0px 0px 0px 3px #E0EAFF`};
    }
    &:active{
      border: ${({theme}) => theme.isDark ? `1px solid #4671F6` : `1px solid ${theme.primary[300]}`};
      box-shadow: ${({theme}) => theme.isDark ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)' : `0px 0px 0px 3px #E0EAFF`};
    }
    &:hover{
      border: ${({theme}) => theme.isDark ? `1px solid #4671F6` : `1px solid ${theme.primary[300]}`};
      box-shadow: ${({theme}) => theme.isDark ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)' : `0px 0px 0px 3px #E0EAFF`};

    }
  }
  [data-slot="cell"] {

    .data-\[selected\=true\]\:bg-primary[data-selected="true"] {
      background-color: ${({theme}) => theme.primary[700]}!important;
      color:#FFF;
    }
    [data-selected] {
      background-color: ${({theme}) => theme.primary[700]}!important;
      color:#FFF;
    }
  }
`